(ns ncr.search.selection
  (:require
   [clojure.set :as set]
   [ncr.etc.profile :as p]))

(def pspec [:session "ui/search/selected"])
(def default #{})

(defn use-selected []
  @(p/use-profile pspec default))

(defn select! [id]
  (p/swap-profile! pspec default conj id))

(defn deselect! [id]
  (p/swap-profile! pspec default disj id))

(defn keep! [ids]
  (p/swap-profile! pspec default set/intersection (set ids)))

(defn set! [ids]
  (p/write-profile! pspec (into default ids)))

(defn clear! []
  (p/write-profile! pspec default))